/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomerDocumentsStatus {
    COMPLETED = 'Completed',
    OPEN = 'Open',
}
